export const tableTitle = ['Id', 'Назва лікарні', 'Реквізити ЄДРПОУ', 'Директор медичного закладу', 'Місто', ''];

export const filterDate = [
    {name: 'id', placeholder: 'Пошук за id'},
    {name: 'name', placeholder: 'Пошук за назвою закладу'},
    {name: 'edrpou', placeholder: "Пошук за реквізитами"},
    {name: 'medicalDirector', placeholder: 'Пошук за ПІБ директора'},
    {name: 'city', placeholder: 'Пошук за містом'},
];

export const searchOptions = [
    {value: "id", name: "за ID", type: "text"},
    {value: "name", name: "за назвою закладу", type: "text"},
    {value: "edrpou", name: "за реквізитами", type: "text"},
    {value: "medicalDirector", name: "Пошук за ПІБ директора", type: "text"},
    {value: "city", name: "Пошук за містом", type: "text"},
];